import React from "react";
import "!style-loader!css-loader!./styles.css";

export const NavItemText = ({ children, className, ...props }) => (
  <span className={`nav-item-text ${className}`} {...props}>
    {children}
  </span>
);

export const NavHelpSettings = ({ children, className, ...props }) => (
  <div className={`nav-help-settings ${className}`} {...props}>
    {children}
  </div>
);

export const HelpSettingsButtonMobile = ({ children, className, ...props }) => (
  <span className={`help-settings-button-mobile ${className}`} {...props}>
    {children}
  </span>
);

export const HelpSettingsButtonLarge = ({ children, className, ...props }) => (
  <span className={`help-settings-button-large ${className}`} {...props}>
    {children}
  </span>
);

export const LogoImgSmall = ({ className, ...props }) => (
  <img className={`logo-img-small ${className}`} {...props} />
);

export const LogoImgBig = ({ className, ...props }) => (
  <img className={`logo-img-big ${className}`} {...props} />
);

export const HorizontalRuleMobile = ({ className, ...props }) => (
  <hr className={`horizontal-rule-mobile ${className}`} {...props} />
);
